/* unplugin-vue-components disabled */import script from "./TenantContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantContent.vue?vue&type=script&setup=true&lang=js"

import "./TenantContent.vue?vue&type=style&index=0&id=29801ce4&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29801ce4"]])

export default __exports__